"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function useStyles(stylesModule) {
  var doesUseFunctionExists = stylesModule.use && typeof stylesModule.use === 'function';
  react_1.default.useEffect(function () {
    if (!doesUseFunctionExists) {
      return;
    }

    stylesModule.use();
    return stylesModule.unuse;
  }, []);

  if (!doesUseFunctionExists) {
    return stylesModule;
  }

  return stylesModule.locals;
}

exports.default = useStyles;